/** Keep one editable row per dispatch group, with independent card membership. */
export function mergeDropReleasedBoards<T extends { pronumber: number; legnum?: number }>(
  ready: T[],
  notDispatched: T[],
): Array<T & { plannerDropReleased: boolean; dropReleasedNotDispatched: boolean }> {
  const key = (order: T) => `${order.pronumber}-${order.legnum || 0}`;
  const dashboardKeys = new Set(notDispatched.map(key));
  const readyKeys = new Set(ready.map(key));
  return [
    ...ready.map(order => ({ ...order, plannerDropReleased: true, dropReleasedNotDispatched: dashboardKeys.has(key(order)) })),
    ...notDispatched.filter(order => !readyKeys.has(key(order))).map(order => ({
      ...order, plannerDropReleased: false, dropReleasedNotDispatched: true,
    })),
  ];
}
